import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/search.svg'
import _imports_2 from '@/assets/img/chevronRight.svg'


const _hoisted_1 = { class: "hasHeader bgWhite fullHeightModal" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "searchContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "socialImage groupImage" }, null, -1)
const _hoisted_7 = { class: "socialDetails w-100 d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "socialName" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "fs-14 text-center mt-3"
}
const _hoisted_11 = { class: "socialImage" }
const _hoisted_12 = { class: "socialDetails" }
const _hoisted_13 = { class: "socialName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ms-1 me-3 d-flex align-items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncia && _ctx.debouncia(...args))),
          class: "searchInput ms-2"
        }, null, 544), [
          [_directive_localizedPlaceholder, { key: 'app_cercaUtente', value: 'Cerca utente...' }]
        ])
      ])
    ]),
    _createVNode("div", {
      class: "socialRow",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createChatRoom && _ctx.createChatRoom(...args)))
    }, [
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_nuovogruppo",
            text: "Nuovo gruppo",
            class: "fs_14 greyBlue d-block ln_12"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "app_creanuovogruppo",
            text: "Crea un nuovo gruppo",
            class: "fs_12 grey d-block"
          })
        ]),
        _hoisted_9
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
      : (_ctx.users.length == 0)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_nessunutentetrovato",
              text: "Nessun utente trovato",
              class: "fs_14 greyBlue d-block mb-1"
            })
          ]))
        : (_ctx.users.length > 0)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.users, (item, i) => {
              return (_openBlock(), _createBlock("div", {
                class: "socialRow",
                key: i,
                onClick: ($event: any) => (_ctx.open(item))
              }, [
                _withDirectives(_createVNode("div", _hoisted_11, null, 512), [
                  [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, _toDisplayString(item.name), 1)
                ])
              ], 8, ["onClick"]))
            }), 128))
          : _createCommentVNode("", true)
  ]))
}